import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=245024db"
import script from "./Records.vue?vue&type=script&lang=ts"
export * from "./Records.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Records.vue?vue&type=style&index=1&id=245024db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports